import { tenderLists } from "./mock";
import withAwardsNTenders from "../HOC/withAwardsNTenders";
import withHeaderFooterHOC from "../HOC/withHeaderFooterHOC";

const HomeAwardedContracts = () => withAwardsNTenders(null)({ data: tenderLists, title: "tenders" });

export default withHeaderFooterHOC(HomeAwardedContracts);
